export default __webpack_public_path__ + "static/media/header-bg.94080992.jpg";